module.exports = __webpack_public_path__ + "static/media/Map.5a72c4fd.png";